"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useReevoo_1 = require("../../hooks/useReevoo");
const ReevooCustomerExperience = ({ reviewsPerPage }) => {
    const isReevooLoaded = (0, useReevoo_1.useReevoo)();
    return isReevooLoaded ? (0, jsx_runtime_1.jsx)("reevoo-embeddable", { type: "brand", "per-page": reviewsPerPage }) : null;
};
exports.default = ReevooCustomerExperience;
